/** An enumeration containing available attachment types. */
export var AttachmentType;
(function (AttachmentType) {
    /** Indicates the attachment is a user manual. */
    AttachmentType["Document"] = "DOCUMENT";
    /** Indicates the attachment is an image. */
    AttachmentType["Image"] = "IMAGE";
    /** Indicates the attachment is a video. */
    AttachmentType["Video"] = "VIDEO";
})(AttachmentType || (AttachmentType = {}));
/** Enumeration of compatible brand field names that support sorting. */
export var CompatibleBrandSortField;
(function (CompatibleBrandSortField) {
    /** The name field. */
    CompatibleBrandSortField["Name"] = "NAME";
    /** The popularity field. */
    CompatibleBrandSortField["Popularity"] = "POPULARITY";
})(CompatibleBrandSortField || (CompatibleBrandSortField = {}));
/** Enumeration of compatible product family field names that support sorting. */
export var CompatibleProductFamilySortField;
(function (CompatibleProductFamilySortField) {
    /** The name field. */
    CompatibleProductFamilySortField["Name"] = "NAME";
    /** The popularity field. */
    CompatibleProductFamilySortField["Popularity"] = "POPULARITY";
})(CompatibleProductFamilySortField || (CompatibleProductFamilySortField = {}));
/** An enum type that contains all availabled contract duration units. */
export var ContractDurationUnit;
(function (ContractDurationUnit) {
    /** Represents months. */
    ContractDurationUnit["Months"] = "MONTHS";
})(ContractDurationUnit || (ContractDurationUnit = {}));
/** An enum type for contract providers. */
export var ContractProviderKey;
(function (ContractProviderKey) {
    /** Telekom Vertriebspartnerportal */
    ContractProviderKey["Tvpp"] = "TVPP";
})(ContractProviderKey || (ContractProviderKey = {}));
/** An enum type for dimension units. */
export var DimensionUnit;
(function (DimensionUnit) {
    /** Centimeters (cm) */
    DimensionUnit["Cm"] = "CM";
    /** Inches (in) */
    DimensionUnit["In"] = "IN";
    /** Millimeters (mm) */
    DimensionUnit["Mm"] = "MM";
})(DimensionUnit || (DimensionUnit = {}));
/** An enum type for duration units. */
export var DurationUnit;
(function (DurationUnit) {
    /** Days */
    DurationUnit["Days"] = "DAYS";
    /** Weeks */
    DurationUnit["Weeks"] = "WEEKS";
})(DurationUnit || (DurationUnit = {}));
/** An enum type that contains all EU energy efficiency classes. */
export var EnergyEfficiencyClass;
(function (EnergyEfficiencyClass) {
    /** The A energy label. */
    EnergyEfficiencyClass["A"] = "A";
    /** The A++ energy label. */
    EnergyEfficiencyClass["ADoublePlus"] = "A_DOUBLE_PLUS";
    /** The A+ energy label. */
    EnergyEfficiencyClass["APlus"] = "A_PLUS";
    /** The A+++ energy label. */
    EnergyEfficiencyClass["ATriplePlus"] = "A_TRIPLE_PLUS";
    /** The B energy label. */
    EnergyEfficiencyClass["B"] = "B";
    /** The C energy label. */
    EnergyEfficiencyClass["C"] = "C";
    /** The D energy label. */
    EnergyEfficiencyClass["D"] = "D";
    /** The E energy label. */
    EnergyEfficiencyClass["E"] = "E";
    /** The F energy label. */
    EnergyEfficiencyClass["F"] = "F";
    /** The G energy label. */
    EnergyEfficiencyClass["G"] = "G";
})(EnergyEfficiencyClass || (EnergyEfficiencyClass = {}));
/** Enumeration of kompa product field names that support sorting. */
export var KompaProductSortField;
(function (KompaProductSortField) {
    /** The product brand. */
    KompaProductSortField["Brand"] = "BRAND";
    /** The priority field. */
    KompaProductSortField["Priority"] = "PRIORITY";
})(KompaProductSortField || (KompaProductSortField = {}));
/** An enum type for memory units. */
export var MemoryUnit;
(function (MemoryUnit) {
    /** Bytes */
    MemoryUnit["B"] = "B";
    /** Gigabytes (GB) */
    MemoryUnit["Gb"] = "GB";
    /** Kilobytes (kB) */
    MemoryUnit["Kb"] = "KB";
    /** Megabytes (MB) */
    MemoryUnit["Mb"] = "MB";
    /** Terabytes (TB) */
    MemoryUnit["Tb"] = "TB";
})(MemoryUnit || (MemoryUnit = {}));
/** The fields that published offers can be sorted by. */
export var OfferSortField;
(function (OfferSortField) {
    /** The insertion time field. */
    OfferSortField["InsertedAt"] = "INSERTED_AT";
    /** The offer name, composed of product and contract name. */
    OfferSortField["Name"] = "NAME";
    /** The onetime price. */
    OfferSortField["OnetimePrice"] = "ONETIME_PRICE";
    /** The manually defined position field. */
    OfferSortField["Recommendation"] = "RECOMMENDATION";
    /** The relevance as automatically determined by the search engine. */
    OfferSortField["Relevance"] = "RELEVANCE";
})(OfferSortField || (OfferSortField = {}));
/** The type of an offer. */
export var OfferType;
(function (OfferType) {
    /** The offer contains only a contract. */
    OfferType["Intangible"] = "INTANGIBLE";
    /** The offer contains a product or bundle and a contract. */
    OfferType["Mixed"] = "MIXED";
    /** The offer contains only a product or bundle. */
    OfferType["Tangible"] = "TANGIBLE";
})(OfferType || (OfferType = {}));
/** An enum type for import origins. */
export var Origin;
(function (Origin) {
    /** Brodos AG */
    Origin["Brodos"] = "BRODOS";
    /** DeinDesign */
    Origin["Deindesign"] = "DEINDESIGN";
    /** Telekom Phoenix Shop Database */
    Origin["Pxsdb"] = "PXSDB";
})(Origin || (Origin = {}));
/** The payment frequency of a price. */
export var PaymentFrequency;
(function (PaymentFrequency) {
    /** A price that is due for payment every month. */
    PaymentFrequency["Monthly"] = "MONTHLY";
    /** A price that is paid once. */
    PaymentFrequency["Onetime"] = "ONETIME";
})(PaymentFrequency || (PaymentFrequency = {}));
/** The type of a price. */
export var PriceType;
(function (PriceType) {
    /** A normal price. */
    PriceType["Default"] = "DEFAULT";
    /** A was-price which is usually the retail price as recommended by the seller or manufacturer. */
    PriceType["Was"] = "WAS";
})(PriceType || (PriceType = {}));
/** The fields that categories can be sorted by. */
export var ProductCategorySortField;
(function (ProductCategorySortField) {
    /** The product category name. */
    ProductCategorySortField["Name"] = "NAME";
})(ProductCategorySortField || (ProductCategorySortField = {}));
/** An enum representing the chromaticity of a product. */
export var ProductChromaticity;
(function (ProductChromaticity) {
    /** The product has multiple colors. */
    ProductChromaticity["Colorful"] = "COLORFUL";
    /** The product has no colors. */
    ProductChromaticity["Colorless"] = "COLORLESS";
    /** The product has a single color. */
    ProductChromaticity["Monochromatic"] = "MONOCHROMATIC";
})(ProductChromaticity || (ProductChromaticity = {}));
/** An enum type for product customizabilities. */
export var ProductCustomizability;
(function (ProductCustomizability) {
    /** Product is fully customizable */
    ProductCustomizability["Full"] = "FULL";
    /** Product is not customizable */
    ProductCustomizability["None"] = "NONE";
    /** Product is partially customizable, eg by adding a text */
    ProductCustomizability["Partial"] = "PARTIAL";
})(ProductCustomizability || (ProductCustomizability = {}));
/** Enumeration of product design tag field names that support sorting. */
export var ProductDesignTagSortField;
(function (ProductDesignTagSortField) {
    /** The name field. */
    ProductDesignTagSortField["Name"] = "NAME";
    /** The popularity field. */
    ProductDesignTagSortField["Popularity"] = "POPULARITY";
})(ProductDesignTagSortField || (ProductDesignTagSortField = {}));
/** An enum type for product providers. */
export var ProductProviderKey;
(function (ProductProviderKey) {
    /** Brodos AG */
    ProductProviderKey["Brodos"] = "BRODOS";
    /** Telekom Deutschland GmbH */
    ProductProviderKey["Telekom"] = "TELEKOM";
    /** Telekom Vertriebspartnerportal */
    ProductProviderKey["Tvpp"] = "TVPP";
})(ProductProviderKey || (ProductProviderKey = {}));
/** An enumeration that contains fields which can be used as selector. */
export var ProductSelectorField;
(function (ProductSelectorField) {
    /** The color field. */
    ProductSelectorField["Color"] = "COLOR";
    /** The memory field. */
    ProductSelectorField["Memory"] = "MEMORY";
    /** The size field. */
    ProductSelectorField["Size"] = "SIZE";
    /** The storage field. */
    ProductSelectorField["Storage"] = "STORAGE";
})(ProductSelectorField || (ProductSelectorField = {}));
/** An enumeration that controls the direction of sorting. */
export var SortDirection;
(function (SortDirection) {
    /** Sorts a field in ascending order. */
    SortDirection["Asc"] = "ASC";
    /** Sorts a field in descending order. */
    SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));
/** An enum type for weight units. */
export var WeightUnit;
(function (WeightUnit) {
    /** Grams (g) */
    WeightUnit["G"] = "G";
    /** Kilograms (kg) */
    WeightUnit["Kg"] = "KG";
})(WeightUnit || (WeightUnit = {}));
